<template>
  <div class="chart-1 d-flex align-center justify-center" v-resize="onResize">
    <Loader v-if="loading"></Loader>
    <div v-else id="chart-1"></div>
  </div>
</template>

<script>
import echarts from 'echarts'
import API from '@/service'
import Loader from '@/components/UI/Loader'
// import { numberFormat } from '@/utils'
export default {
  components: {
    Loader
  },
  data: () => ({
    chart: null,
    option: {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}:  ({d}%)'
        // formatter: (value, index) => {
        //   return `总额：${numberFormat(value.value)}`
        // }
      },
      legend: {
        bottom: 0,
        icon: 'circle',
        orient: 'horizontal',
        data: [],
        left: 'center'
      },
      series: [{
        name: '占比',
        type: 'pie',
        radius: '60%',
        // avoidLabelOverlap: false,
        label: {
          normal: {
            formatter: '{b}' + '\n\r' + '({d}%)',
            show: true
          },
          emphasis: {
            show: true,
            textStyle: {
              fontWeight: 'bold'
            }
          }
        },
        labelLine: {
          normal: {
            show: true
          }
        },
        data: [],
        color: ['#dd6b66', '#759aa0', '#e69d87', '#8dc1a9', '#ea7e53', '#eedd78', '#73a373', '#73b9bc', '#7289ab', '#91ca8c', '#f49f42']
      }]
    },
    loading: true
  }),
  async mounted () {
    try {
      const res = await API.getTransactionList()
      this.option.legend.data = res.data.map(item => item.materialClassName)
      this.option.series[0].data = res.data.map(item => ({
        materialClassCode: item.materialClassCode,
        name: item.materialClassName,
        value: item.bidWinTotalMoney,
        bidWinNum: item.bidWinNum
      }))
      this.option.series[0].data.forEach(item => {
        if (item.materialClassCode === '0101') {
          item.value = item.bidWinNum * 4000
        }
      })
    } catch (error) {
      console.log(error)
    }
    this.loading = false
    this.$nextTick(() => {
      this.chart = echarts.init(document.getElementById('chart-1'))
      this.chart.setOption(this.option)
    })
  },
  methods: {
    onResize () {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-1, #chart-1 {
  width: 100%;
  height: 400px;
}
</style>
